/**
 * Middleware to disable the loader
 *
 * @param {Function} loader     the loader middleware
 * @param {Object} middleware   residual middleware
 * @returns {*[]}
 */
export default ({ loader, ...middleware }) => Object.values(middleware)
